import "./scripts/carousel";

import "./styles/carousel.scss";
import "./styles/featurettes.scss";
import "./styles/home.scss";
